<template>
<v-container>
  <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>

  <template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" style="color:white;">
            Tank Water Level Sensor Label
          </th>
           <th class="text-left" style="color:white;">
            Tank Water Level Sensor S/N
          </th>
          <th class="text-left" style="color:white;">
            Power Source
          </th>
          <th class="text-left" style="color:white;">
            Location Description
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in waterTank"
          :key="item.waterTankConsole"
        >
          <td>{{ item.waterTankSensor }}</td>
          <td>{{ item.waterTankSensorSn.serialNumber }}</td>
          <td>{{ item.boardName }}</td>
          <td>{{ item.locationRemarks }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  
</template>
<v-btn fixed dark fab bottom right color="green" :to="{ name: 'Water Tank Edit', params: { id: this.$route.params.id } }">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
</v-container>
</template>

<script>
import axios from "axios";

  export default {
    data () {
      return {
        items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Water Tank',
          disabled: false,
          href: '/water-tank',
        },
        {
          text: 'Details',
          disabled: true,
          href: '',
        },
      ],
        waterTank: []
      }
    },
    mounted() {
    this.loadsWaterTank();
  },
    methods:{
      loadsWaterTank: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/water-tank-all/" + this.$route.params.id;
      axios.get(apiURL).then(res => {
      this.waterTank = res.data;
      }).catch(error => {
      console.log(error)
      });
},
    }
  }
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>